module.exports = __webpack_public_path__ + "media/app/images/envelope-icon-940c67af2e706b9f64a4e46f03119282.png";